import { createContext } from 'react';
import { getResponse } from '../helpers/UtilsHelper';

const account = {
    uid: '',
    displayName: '',
    photoURL: '',
    tokenVzLaML: {
        id: '',
        token: '',
    },
    role: {
        roleUserId: '',
        roleDate: '',
        role: '',
        roleId: '',
    },
};

export const AuthContextType = {
    account: account,
    login: async ({
        email = '',
        password = '',
        rememberMe = false,
        accountDataSave = false,
        reCaptchaToken = '',
        languageId = '',
        subMethod = ''
    }) => getResponse({ type: 0 }),
    logout: ({
        savePath = false,
        subMethod = '',
    }) => getResponse({ type: 0 }),
    setAccountLocal: ({
        accountML = {},
        accountFirebase = {},
        token = {},
        role = {},
        subMethod = '',
    }) => getResponse({ type: 0 }),
    isLoged: () => true || false,
    removeAccount: ({
        subMethod = '',
    }) => getResponse({ type: 0 }),
    updateAccountLocal: ({
        accountNew = {},
        subMethod = '',
    }) => getResponse({ type: 0 }),
};

export const AuthContext = createContext();